import { api } from '@shared/config/axiosConfig';
import { buildEndpoint } from '@shared/utils/buildEndpoint';
import { validateRequiredFields } from '@shared/utils/validateRequiredFields';
import { insuranceCarrierConfigurationCreateToDto, insuranceCarrierConfigurationFromDto, insuranceCarrierConfigurationUpdateToDto } from '@features/insuranceCarriers/mappers/insuranceCarrierConfigurationsMapper';

const BASE_ENDPOINT = 'insurance-carriers';

const buildServiceEndpoint = ({ insuranceCarrierId, configurationId, action } = {}) => {
  return buildEndpoint(BASE_ENDPOINT, { id: insuranceCarrierId }, ['configurations', configurationId, action]);
};

export const getInsuranceCarrierConfigurations = async (insuranceCarrierId, data = {}) => {
  validateRequiredFields({ insuranceCarrierId });

  const params = {
    connection_type_code: data.connectionTypeCode,
  }

  const endpoint = buildServiceEndpoint({ insuranceCarrierId });
  const response = await api.get(endpoint, { params });
  return response.data.map(insuranceCarrierConfigurationFromDto);
};

export const createInsuranceCarrierConfiguration = async (insuranceCarrierId, data) => {
  validateRequiredFields({ insuranceCarrierId });

  const payload = insuranceCarrierConfigurationCreateToDto(data);
  const endpoint = buildServiceEndpoint({ insuranceCarrierId });
  const response = await api.post(endpoint, payload);
  return insuranceCarrierConfigurationFromDto(response.data);
};

export const updateInsuranceCarrierConfiguration = async (insuranceCarrierId, configurationId, data) => {
  validateRequiredFields({ insuranceCarrierId, configurationId });

  const payload = insuranceCarrierConfigurationUpdateToDto(data);
  const endpoint = buildServiceEndpoint({ insuranceCarrierId, configurationId });
  const response = await api.patch(endpoint, payload);
  return insuranceCarrierConfigurationFromDto(response.data);
};

export const deleteInsuranceCarrierConfiguration = async (insuranceCarrierId, configurationId) => {
  validateRequiredFields({ insuranceCarrierId, configurationId });

  const endpoint = buildServiceEndpoint({ insuranceCarrierId, configurationId });
  await api.delete(endpoint);
};
